import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { useParams, useNavigate } from 'react-router-dom'

/**
 * Redirect shim. The standalone agent-execute page is being folded into
 * Playground — which has the full set of per-agent output renderers — so
 * `/agents/:id/execute` now just forwards to `/playground?agent=:id`.
 *
 * See PLAN-argus-demo-and-agent-output-renderers.md §3.4 option (A).
 */
const AgentExecutePage = observer(() => {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()

  useEffect(() => {
    const target = id ? `/playground?agent=${encodeURIComponent(id)}` : '/playground'
    navigate(target, { replace: true })
  }, [id, navigate])

  return (
    <div className="p-6 text-sm text-muted-foreground">
      Opening this agent in Playground…
    </div>
  )
})

export default AgentExecutePage
